<div class="page-container">
  <div class="page-header">
    <button mat-icon-button routerLink="/automakers">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div>
      <h2 class="page-title">Importar Pedidos</h2>
      <p class="page-subtitle">Selecione o arquivo para importação de pedidos</p>
    </div>
  </div>
  <mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="loading">
    <div class="form-section">
      <form [formGroup]="form" class="flex flex-col gap-5 w-full">
        <div class="flex flex-row">
          <mat-form-field subscriptSizing="dynamic" class="w-2on6">
            <mat-label>Montadora (OE)</mat-label>
            <input matInput type="text" [value]="automaker?.company?.tradeName" disabled />
          </mat-form-field>
        </div>
        <div class="flex flex-row">
          <mat-form-field class="w-2on6">
            <mat-label>Arquivo</mat-label>
            <input
              matInput
              placeholder="Selecione um arquivo"
              [value]="selectedFiles ? selectedFiles.item(0)?.name : ''"
              (click)="fillFileInput.click()"
              autocomplete="off"
              formControlName="file"
              readonly
              />
              <input hidden #fillFileInput type="file" id="fillFileInput" autocomplete="off" accept=".txt,.xlsx,.xls,.csv" (change)="selectFile($event)" />
              <mat-hint>Tipo de arquivo: .txt, .xlsx, .xls ou .csv</mat-hint>
              <button mat-icon-button matSuffix color="primary" (click)="fillFileInput.click()">
                <mat-icon>open_in_browser</mat-icon>
              </button>
            </mat-form-field>
          </div>
          @if (errorMessage) {
            <div class="mt-4"><span style="color: red;">{{ errorMessage }}</span></div>
          }
        </form>
    </div>
    <div class="form-actions">
      <button mat-stroked-button color="primary" routerLink="/automakers">
        <mat-icon>close</mat-icon><span>Cancelar</span>
      </button>
      <button mat-flat-button color="primary" class="mic-btn-icon-left" [disabled]="form.invalid" (click)="submitForm()">
        <mat-icon>check</mat-icon><span>Confirmar</span>
      </button>
    </div>
  </mic-spinner-overlay>
</div>
